import { z } from 'zod'

export const planStopEntityTypeValues = ['event', 'listing', 'place'] as const
export const planStopSourceValues = ['deck', 'chat_add', 'manual'] as const

/** Display cache captured when the stop is added, so a stop whose entity was
 * deleted (FK set null) still renders in the timeline. */
export const planStopSnapshotSchema = z.object({
  title: z.string(),
  coverImageUrl: z.string().nullable().optional(),
  locationName: z.string().nullable().optional(),
  lat: z.number().nullable().optional(),
  lng: z.number().nullable().optional(),
})

export type PlanStopSnapshot = z.infer<typeof planStopSnapshotSchema>

export const planStopDtoSchema = z.object({
  id: z.string().uuid(),
  planId: z.string().uuid(),
  position: z.number().int().nonnegative(),
  entityType: z.enum(planStopEntityTypeValues).nullable(),
  entityId: z.string().uuid().nullable(),
  title: z.string(),
  snapshot: planStopSnapshotSchema.nullable(),
  timeStart: z.string().nullable(),
  timeEnd: z.string().nullable(),
  addedById: z.string().uuid().nullable(),
  source: z.enum(planStopSourceValues),
  createdAt: z.string(),
})

export type PlanStopDto = z.infer<typeof planStopDtoSchema>

export const addPlanStopSchema = z
  .object({
    eventId: z.string().uuid().optional(),
    listingId: z.string().uuid().optional(),
    placeId: z.string().uuid().optional(),
    timeStart: z.string().time().nullable().optional(),
    timeEnd: z.string().time().nullable().optional(),
    source: z.enum(['chat_add', 'manual']).default('manual'),
  })
  .refine((d) => [d.eventId, d.listingId, d.placeId].filter(Boolean).length === 1, {
    message: 'Provide exactly one of eventId, listingId, placeId',
  })

export type AddPlanStopInput = z.infer<typeof addPlanStopSchema>

export const planStopResponseSchema = z.object({
  stop: planStopDtoSchema,
})

export type PlanStopResponse = z.infer<typeof planStopResponseSchema>
